import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";

const SiteMap = () => {
  const sections = [
    {
      title: "About Company",
      links: [
        { name: "About HLC", path: "/about-hlc" },
        { name: "News & Events", path: "/news-events" },
        { name: "Careers", path: "/careers" },
        { name: "Dealer Portal", path: "/dealer-portal" },
      ],
    },
    {
      title: "Customer Support",
      links: [
        { name: "Contact Us", path: "/contact" },
        { name: "FAQs", path: "/faqs" },
        { name: "Warranty", path: "/warranty" },
        { name: "Shipping & Returns", path: "/shipping-returns" },
        { name: "Store Locator", path: "/store-locator" },
      ],
    },
  {
    title: "Lighting Learning Center",
    links: [
      { name: "LED Basics", path: "/led-basics" },
      { name: "Home Lighting Tips", path: "/home-lighting-tips" },
      { name: "Energy Savings", path: "/energy-savings" },
      { name: "Outdoor & Floods", path: "/outdoor-floods" },
      { name: "Rope Light Ideas", path: "/rope-light-ideas" },
    ],
  },
    // {
    //   title: "Admin Section",
    //   links: [
    //     { name: "Dashboard", path: "/admin-dashboard" },
    //     { name: "Products", path: "/products" },
    //     { name: "Orders", path: "/orders" },
    //     { name: "Reports", path: "/reports" },
    //   ],
    // },
  ];

  return (
    <>
      <Navbar />

      <div className="min-h-screen bg-gray-100 p-6 mt-20">
        <h1 className="text-3xl font-extrabold text-center text-transparent bg-clip-text bg-gradient-to-r from-purple-800 to-pink-500 mb-10">
    
        </h1>

        <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {sections.map((section, index) => (
            <motion.div
              key={index}
              className="bg-white rounded-2xl shadow-md p-6 hover:shadow-xl transition"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
            >
              <h2 className="text-lg font-bold text-gray-800 mb-3 border-b pb-2 border-gray-200">
                {section.title}
              </h2>
              <ul className="space-y-2">
                {section.links.map((link, i) => (
                  <li key={i}>
                    <Link
                      to={link.path}
                      className="text-gray-600 hover:text-purple-600 transition text-sm flex items-center gap-1"
                    >
                      <span className="text-purple-500">→</span> {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>

        <motion.div
          className="text-center mt-10 text-gray-600 text-sm"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.8 }}
        >
          © {new Date().getFullYear()} HLC Lighting — All Rights Reserved.
        </motion.div>
      </div>
    </>
  );
};

export default SiteMap;
